import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { courseGetFlrstInfo } from 'dsoapi';

const InProgressTab = ({ courses }) => {
  const [flrstInfoMap, setFlrstInfoMap] = useState({});

  useEffect(() => {
    const fetchFlrstInfo = async () => {
      const flrstCourses = courses.filter(
        (course) => course.courseAbbreviation === 'FLRST'
      );
      const infoMap = {};

      for (const course of flrstCourses) {
        try {
          const resp = await courseGetFlrstInfo(course.userCourseEnrollmentId);
          const flrstInfo = resp?.data?.fedsUserFlrstInfo;

          // Check guardian driver license
          const guardianDriverLicenseNumber =
            flrstInfo?.guardianDriverLicenseNumber || null;

          // Check WebTestURL in exams field
          let webTestURL = null;
          const exams = flrstInfo?.exams;
          try {
            const examsObj =
              typeof exams === 'string' ? JSON.parse(exams) : exams;
            webTestURL =
              examsObj?.TestAuthorizationResponse?.WebTestURL || null;
          } catch (err) {
            webTestURL = null;
          }

          infoMap[course.userCourseEnrollmentId] = {
            guardianDriverLicenseNumber,
            webTestURL,
          };
        } catch (error) {
          console.error(
            'Error fetching FLRST info for course:',
            course.userCourseEnrollmentId,
            error
          );
          infoMap[course.userCourseEnrollmentId] = {
            guardianDriverLicenseNumber: null,
            webTestURL: null,
          };
        }
      }

      setFlrstInfoMap(infoMap);
    };

    if (courses.some((course) => course.courseAbbreviation === 'FLRST')) {
      fetchFlrstInfo();
    }
  }, [courses]);

  const renderCourseItem = (course) => {
    return (
      <div className="item" key={course.userCourseEnrollmentId}>
        {course.currentPageHashLink && (
          <div className="right floated content">
            <Link
              to={`/courseapp/${course.currentPageHashLink}`}
              className="ui primary button"
            >
              Resume
            </Link>
          </div>
        )}
        {!course.currentPageHashLink && (
          <div
            className="right floated content error"
            style={{ height: '36px' }}
          >
            course page status error
          </div>
        )}
        <div className="header">{course.displayName}</div>
      </div>
    );
  };

  const renderFPPQ = (course) => {
    return (
      <div className="item" key={course.userCourseEnrollmentId}>
        <div className="right floated content">
          <Link
            to={`/floridapermitpractice/${course.userCourseEnrollmentId}`}
            className="ui primary button"
          >
            Practice
          </Link>
        </div>
        <div className="header">{course.displayName}</div>
      </div>
    );
  };

  const renderFPSG = (course) => {
    return (
      <div className="item" key={course.userCourseEnrollmentId}>
        <div className="right floated content">
          <Link
            to={`/floridapermitstudyguide/${course.userCourseEnrollmentId}`}
            className="ui primary button"
          >
            Study
          </Link>
        </div>
        <div className="header">{course.displayName}</div>
      </div>
    );
  };

  const renderFloridaRoadSignTest = (course) => {
    const flrstInfo = flrstInfoMap[course.userCourseEnrollmentId];
    const hasGuardianLicense =
      flrstInfo?.guardianDriverLicenseNumber &&
      flrstInfo.guardianDriverLicenseNumber.trim() !== '';

    const hasWebTestURL =
      flrstInfo?.webTestURL && flrstInfo.webTestURL.trim() !== '';

    let linkPath;

    // If no guardian license, go to acknowledgement
    if (!hasGuardianLicense) {
      linkPath = `/floridaacknowledgement/${course.userCourseEnrollmentId}`;
    }
    // If has guardian license but no WebTestURL, go to exam directions
    else if (!hasWebTestURL) {
      linkPath = `/floridaexamdirections/${course.userCourseEnrollmentId}`;
    }
    // If has both guardian license and WebTestURL, go directly to exam
    else {
      linkPath = `/floridaroadsign/${course.userCourseEnrollmentId}`;
    }

    return (
      <div className="item" key={course.userCourseEnrollmentId}>
        <div className="right floated content">
          <Link to={linkPath} className="ui primary button">
            Take Road & Sign Test
          </Link>
        </div>
        <div className="header">{course.displayName}</div>
      </div>
    );
  };

  const renderList = () => {
    return courses
      .filter((course) => course.courseStatus !== 3) // exclude adi12 courses being graded
      .map((course) => {
        switch (course.courseAbbreviation) {
          case 'FLRST':
            return renderFloridaRoadSignTest(course);
          case 'FPPQ':
            return renderFPPQ(course);
          case 'FPSG':
            return renderFPSG(course);
          default:
            return renderCourseItem(course);
        }
      });
  };

  return (
    <>
      {courses.length === 0 && <p>No courses in progress.</p>}
      {courses.length > 0 && (
        <div className="ui middle aligned divided list">{renderList()}</div>
      )}
    </>
  );
};

export default InProgressTab;
